import { Types } from '../actionTypes';

const initialState = []
  

const sidebarItems = (state = initialState, action) => {
  switch (action.type) {
    // case Types.ADD_AUDIT_SCHEDULE:
    //        return [ ...state, 
    //         action.payload.data];
    case Types.GET_SIDEBAR_ITEMS:
      {
       // console.log("from reducer of sidebar")
      return state=action.payload;
      }

    case Types.DEL_SIDEBAR_ITEMS:
      {

        return state = initialState;
      }
    default:
      return state;
  }
}

export default sidebarItems;
